import apiV2 from '../api/v2';
import { toDmError } from './dmErrors';

export type DmQuickReplyOwnerType = 'doctor' | 'dso';

// `title` is staff-facing only: show it in the composer, never in the message text.
export interface DmQuickReplyMedia {
    id: number;
    title: string;
    mimeType: string;
}

export interface DmQuickReply {
    key: string;
    title: string;
    content: string;
    ownerType: DmQuickReplyOwnerType;
    hasMedia: boolean;
    media: DmQuickReplyMedia | null;
}

interface ListQuickRepliesResponse {
    quickReplies: DmQuickReply[];
}

function normalizeMedia(media: unknown): DmQuickReplyMedia | null {
    if (!media || typeof media !== 'object') return null;
    const { id, title, mimeType } = media as Partial<DmQuickReplyMedia>;
    if (typeof id !== 'number' || !Number.isSafeInteger(id)) return null;
    return {
        id,
        title: typeof title === 'string' && title.trim() ? title : 'Quick reply media',
        mimeType: typeof mimeType === 'string' ? mimeType : ''
    };
}

export async function fetchQuickReplies(patientId: string): Promise<DmQuickReply[]> {
    try {
        const response = await apiV2.get<{ success: boolean; data: ListQuickRepliesResponse }>(
            `/patients/${patientId}/dm/quick-replies`
        );
        return response.data.data.quickReplies.map((reply) => ({
            ...reply,
            media: normalizeMedia(reply.media)
        }));
    } catch (err) {
        throw toDmError(err);
    }
}
